export default "__VITE_ASSET__5O7JxV2A__"